import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import usePageAnalytics from "../hooks/usePageAnalytics";

const ScrollToTop = () => {
  const { pathname } = useLocation();

  usePageAnalytics();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};

export default ScrollToTop;
